import { useState } from 'react'
import { Parallax } from 'react-scroll-parallax'

import CSS from './scroll-ticker.module.css'

export const ScrollTicker = ({ children, speed, decal }) => {

    const [ translateX, setTranslateX ] = useState(0)

    return (
        <Parallax  onProgressChange={(progress) => setTranslateX(progress)}>
            <div className={CSS.layout}>
                <p className={`${CSS.content} fs-xl fw-800 ${ decal ? decal : 'c-primary'}`} style={{ transform: `translateX(-${translateX * speed}px)`}}>
                    { children }
                </p>
            </div>
        </Parallax>

    )
}